var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartStyleHollowCandles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71449 4.28571V7.71428H7.42878V4.28571H5.71449ZM5.42878 3.71428H7.71449C7.79027 3.71428 7.86294 3.74438 7.91653 3.79796C7.97011 3.85154 8.00021 3.92422 8.00021 3.99999V7.99999C8.00021 8.07577 7.97011 8.14844 7.91653 8.20202C7.86294 8.25561 7.79027 8.28571 7.71449 8.28571H5.42878C5.353 8.28571 5.28033 8.25561 5.22675 8.20202C5.17317 8.14844 5.14307 8.07577 5.14307 7.99999V3.99999C5.14307 3.92422 5.17317 3.85154 5.22675 3.79796C5.28033 3.74438 5.353 3.71428 5.42878 3.71428Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71408 0.285721H2.2855V3.14286H1.71408V0.285721ZM1.71408 8.28572H2.2855V11.1429H1.71408V8.28572ZM0.856934 3.14286H1.71408V3.71429H0.856934V3.14286ZM2.2855 3.14286H3.14265V3.71429H2.2855V3.14286ZM1.71408 3.71429H2.2855V4.28572H1.71408V3.71429ZM0.856934 4.28572H1.71408V4.85715H0.856934V4.28572ZM2.2855 4.28572H3.14265V4.85715H2.2855V4.28572ZM1.71408 4.85715H2.2855V5.42858H1.71408V4.85715ZM0.856934 5.42858H1.71408V6.00001H0.856934V5.42858ZM2.2855 5.42858H3.14265V6.00001H2.2855V5.42858ZM1.71408 6.00001H2.2855V6.57144H1.71408V6.00001ZM0.856934 6.57144H1.71408V7.14286H0.856934V6.57144ZM2.2855 6.57144H3.14265V7.14286H2.2855V6.57144ZM1.71408 7.14286H2.2855V7.71429H1.71408V7.14286ZM0.856934 7.71429H1.71408V8.28572H0.856934V7.71429ZM2.2855 7.71429H3.14265V8.28572H2.2855V7.71429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartStyleHollowCandles);
export default __webpack_public_path__ + "static/media/chart-style-hollow-candles.d734b592bcb1ebf395b422a567d49828.svg";
export { ForwardRef as ReactComponent };